// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopHeader_wrapper__2unBA","img":"TopHeader_img__1bD_j"};